module.exports = __webpack_public_path__ + "static/img/voucher-preview.5d13d93.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/voucher/voucher-preview.jpg
// module id = 61
// module chunks = 0